import type { Iso2700127701ControlModificacion } from "./control-modificaciones";

export type BooleanFilterValue = "" | "true" | "false";

export type Iso2700127701SoaControl = {
  id: number;
  serie: number | null;
  codigo_grupo: string | null;
  grupo: string | null;
  codigo_control: string;
  control: string;
  detalle: string | null;
  aplica: boolean | null;
  justificacion_soporte_documental: string | null;
  soporte_documental: string | null;
  evidencia_inproeco: string | null;
  actualizacion_2026: string | null;
  observaciones: string | null;
  responsables: string | null;
  comentarios_inproeco: string | null;
  usuario_modificacion_id: number | null;
};

export type Iso2700127701PlanAnexoA = {
  id: number;
  codigo_control: string;
  intervencion: string;
  detalle: string | null;
  aplica: boolean | null;
  seguimiento: string | null;
  usuario_modificacion_id: number | null;
};

export type Iso2700127701DocumentoSistema = {
  id: number;
  nivel: number | null;
  tipo: string | null;
  documento: string;
  modelo_distribucion: string | null;
  fecha_inicial: string | null;
  fecha_ultima_revision: string | null;
  estado: string | null;
  usuario_modificacion_id: number | null;
};

export type Iso2700127701SoaPayload = Omit<Iso2700127701SoaControl, "id" | "usuario_modificacion_id">;
export type Iso2700127701PlanPayload = Omit<Iso2700127701PlanAnexoA, "id" | "usuario_modificacion_id">;
export type Iso2700127701DocumentoSistemaPayload = Omit<Iso2700127701DocumentoSistema, "id" | "usuario_modificacion_id">;

export type Iso2700127701SoaFilters = {
  search: string;
  codigo_control: string;
  grupo: string;
  aplica: BooleanFilterValue;
  responsables: string;
  actualizacion_2026: string;
};

export type Iso2700127701DocumentosSistemaFilters = {
  search: string;
  nivel: string;
  tipo: string;
  modelo_distribucion: string;
  estado: string;
  fecha_inicial_desde: string;
  fecha_inicial_hasta: string;
  fecha_revision_desde: string;
  fecha_revision_hasta: string;
};

export type Iso2700127701SoaResponse = {
  ok: boolean;
  data: {
    soa: Iso2700127701SoaControl[];
    plan_anexo_a: Iso2700127701PlanAnexoA[];
    control_modificaciones: Iso2700127701ControlModificacion[];
  };
  filter_options: {
    grupos: string[];
    responsables: string[];
    actualizaciones_2026: string[];
  };
  meta: {
    soa_total: number;
    plan_anexo_a_total: number;
  };
};

export type Iso2700127701DocumentosSistemaResponse = {
  ok: boolean;
  data: {
    documentos: Iso2700127701DocumentoSistema[];
    control_modificaciones: Iso2700127701ControlModificacion[];
  };
  filter_options: {
    niveles: number[];
    tipos: string[];
    modelos_distribucion: string[];
    estados: string[];
  };
  meta: {
    total: number;
  };
};

export const defaultSoaFilters: Iso2700127701SoaFilters = {
  search: "",
  codigo_control: "",
  grupo: "",
  aplica: "",
  responsables: "",
  actualizacion_2026: "",
};

export const defaultDocumentosSistemaFilters: Iso2700127701DocumentosSistemaFilters = {
  search: "",
  nivel: "",
  tipo: "",
  modelo_distribucion: "",
  estado: "",
  fecha_inicial_desde: "",
  fecha_inicial_hasta: "",
  fecha_revision_desde: "",
  fecha_revision_hasta: "",
};

export function createEmptySoaForm(): Iso2700127701SoaPayload {
  return {
    serie: null,
    codigo_grupo: null,
    grupo: "",
    codigo_control: "",
    control: "",
    detalle: "",
    aplica: null,
    justificacion_soporte_documental: "",
    soporte_documental: "",
    evidencia_inproeco: "",
    actualizacion_2026: "",
    observaciones: "",
    responsables: "",
    comentarios_inproeco: "",
  };
}

export function createEmptyPlanForm(): Iso2700127701PlanPayload {
  return {
    codigo_control: "",
    intervencion: "",
    detalle: "",
    aplica: null,
    seguimiento: "",
  };
}

export function createEmptyDocumentoSistemaForm(): Iso2700127701DocumentoSistemaPayload {
  return {
    nivel: null,
    tipo: "",
    documento: "",
    modelo_distribucion: "",
    fecha_inicial: null,
    fecha_ultima_revision: null,
    estado: "",
  };
}
